<template>
  <v-container fluid>
    <div class="form-inputs">
      <v-alert dense type="error" outlined text dismissible transition="slide-x-transition"
        class="py-0 text-uppercase my-0" v-for="(item, index) in mxStoreUserErrors" :key="index">
        {{ item[0] }}
      </v-alert>
      <v-autocomplete outlined label="Branch" :items="stores" item-value="id" hide-details="auto" item-text="name"
        v-model="storeId"></v-autocomplete>
      <v-autocomplete outlined hide-details="auto" item-value="routeName" item-text="alias" :items="getHomepageList()"
        v-model="homepage" label="Homepage"></v-autocomplete>
      <v-text-field outlined hide-details="auto" v-model="username" label="Username"></v-text-field>
      <v-text-field outlined hide-details="auto" v-model="name" label="Name"></v-text-field>
      <!-- <v-autocomplete label="Role" hide-details="auto" :items="userRoles" v-model="role"></v-autocomplete> -->
      <v-autocomplete outlined label="Role" hide-details="auto" :items="userRoles" v-model="roleId"></v-autocomplete>
      <v-text-field outlined hide-details="auto" v-model="password" label="Password" type="password"></v-text-field>
      <v-text-field outlined hide-details="auto" v-model="confirmPassword" label="Confirm Password"
        type="password"></v-text-field>
      <v-text-field outlined hide-details="auto" v-model="email" label="Email"></v-text-field>
      <div style="height: 44px;display: flex;align-items: center;">
        <v-switch style="margin-top:0px;" hide-details="auto" v-model="active" label="Active"></v-switch>
      </div>
      <v-btn dark color="primary" @click="initStore" :loading="mxStoringUser">Save</v-btn>
    </div>
  </v-container>
</template>
<style scoped lang="scss">
.form-inputs {
  display: grid;
  gap: 10px;
}
</style>
<script>
import axiosExtra from '../../../../../../extra-functions/axios.extra'
import { routeNames } from '../../../../../../router'
import { storeUser } from './../../../../mixins/users.mixin'
import { mapState } from 'vuex'

export default {
  name: 'vCreateUser',
  data() {
    return {
      gettingUserRole: false,
      userRoles: [],
      username: null,
      name: null,
      email: null,
      active: 0,
      storeId: null,
      role: null,
      roleId: null,
      password: null,
      confirmPassword: null,
      homepage: null,
    }
  },
  created() {
    // this.getUserRoles()
    this.getUserRolesV2()
  },
  computed: {
    ...mapState({
      stores: state => state.branchLocation.list,
      token: state => state.auth.token,
    }),
  },
  methods: {
    initStore() {
      this.mxStoreUser({
        username: this.username,
        name: this.name,
        email: this.email,
        store_id: this.storeId,
        // role: this.role,
        homepage: this.homepage,
        role: 'admin',
        role_id: this.roleId,
        password: this.password,
        password_confirmation: this.confirmPassword,
        active: this.active,
      }, () => {
        this.$emit('close-dialog')
      })
    },
    async getUserRolesV2(retries = 0) {
      try {
        const axios = axiosExtra(this.token)
        if (retries > 5) return
        this.gettingUserRole = true
        const { data } = await axios.get('/roles')
        this.userRoles = data ?? []
      } catch (e) {
        setTimeout(() => this.getUserRoles(retries + 1), 3000)
      } finally {
        this.gettingUserRole = false
      }
    },
    getHomepageList() {
      return routeNames
    },
    // async getUserRoles(retries = 0) {
    //   try {
    //     if (retries > 5) return
    //     this.gettingUserRole = true
    //     const { data } = await axiosExtra(this.token).get('/admin/users/roles')
    //     this.userRoles = data ?? []
    //   } catch (e) {
    //     setTimeout(() => this.getUserRoles(retries + 1), 3000)
    //   } finally {
    //     this.gettingUserRole = false
    //   }
    // },
  },
  mixins: [
    storeUser,
  ],
}
</script>
